export enum COMPANY_COLUMNS {
  NAME = 'name',
  SUPPORT_NAME = 'support-name',
  CNPJ = 'cnpj',
  CREATED_AT = 'created-at',
}

export enum COMPANY_CONFIG {
  CADASTRAL_DATA_MATCHING_LAYOUT = 'cadastral-data-matching:layout',
  MOVES_LAYOUT = 'moves:layout',
  HEALTH_DATA_INSIGHTS = 'external_link:insights',
  DIGITAL_HOSPITAL_INSIGHTS = 'digital_hospital:insights',
  COPAY_EXEMPTION = 'copay:exemption',
}

export enum COMPANY_CONFIG_VALUE {
  CADASTRAL_DATA_MATCHING_ALL_LAYOUTS = 'cadastral-data-matching',
  CADASTRAL_DATA_MATCHING_LAYOUT_DEFAULT = 'cadastral-data-matching:default',
}

export enum COMPANY_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
}

export enum COMPANY_CONFIG_ACTIONS {
  CREATE = 'create',
  DELETE = 'delete',
}
